if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.openToken = 0;

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        this.openToken += 1;
        this.abortController?.abort();

        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        if (this.modalContent) this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        this.openToken += 1;
        const token = this.openToken;
        this.abortController?.abort();
        this.abortController = new AbortController();

        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner')?.classList.remove('hidden');

        const productUrl = opener.getAttribute('data-product-url');
        const separator = productUrl.includes('?') ? '&' : '?';
        const requestUrl = `${productUrl}${separator}view=quick-add`;

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => {
            if (!response.ok) throw new Error(`Quick add failed: ${response.status}`);
            return response.text();
          })
          .then((responseText) => {
            if (token !== this.openToken) return;

            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info.ncm-qa, product-info');

            if (!productElement) throw new Error('Quick add view is missing product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            super.show(opener);
          })
          .catch((error) => {
            if (error.name === 'AbortError') return;
            console.error(error);
            if (token !== this.openToken || !this.modalContent) return;
            this.modalContent.innerHTML =
              '<p class="ncm-qa__load-error">Unable to load product options. Please try again.</p>';
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        if (!productElement) return;
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
        if (!productElement.getAttribute('data-view')) {
          productElement.setAttribute('data-view', 'quick-add');
        }
      }

      removeDOMElements(productElement) {
        productElement
          .querySelectorAll('pickup-availability, product-modal, modal-dialog, ncm-sticky-atc, .ncm-fbt, .ncm-installments')
          .forEach((element) => element.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;
        if (!sectionId || sectionId.startsWith('quickadd-')) return;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replaceAll(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }
    }
  );
}
